import React from 'react';
import getContent from '../lib/dictionaryFetcher';
import { QUIZ_CONSTANTS } from '../lib/constants';
import { Link } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';

const FeedbackContent = props => {
  const { feedbackSelected, feedbackSelectionType } = props;
  return (
    <div className="feedback">
      <div className="feedback-text">
        <span>{getContent('quiz', 'feedback.text')}</span>
      </div>
      <div className="feedback-selection">
        <Link
          as="button"
          className={`feedback-quiz-${QUIZ_CONSTANTS.feedback.yes} link-as-button`}
          onClick={e => {
            e.preventDefault();
            feedbackSelected(QUIZ_CONSTANTS.feedback.yes);
          }}
        >
          {getContent('quiz', 'feedback.yes')}
        </Link>
        {feedbackSelectionType && (
          <span className={`feedback-quiz-${feedbackSelectionType}-arrow`} />
        )}
        <span className="feedback-dot" />
        <Link
          as="button"
          className={`feedback-quiz-${QUIZ_CONSTANTS.feedback.no} link-as-button`}
          onClick={e => {
            e.preventDefault();
            feedbackSelected(QUIZ_CONSTANTS.feedback.no);
          }}
        >
          {getContent('quiz', 'feedback.no')}
        </Link>
      </div>
    </div>
  );
};

FeedbackContent.propTypes = {
  feedbackSelected: PropTypes.func,
  feedbackSelectionType: PropTypes.string
};

export default FeedbackContent;
